// Standard inner-page header: premium title + one-line description on the left,
// page actions on the right. Every page uses it so titles sit in the same place.
const PageHeader = ({ title, description, children }) => (
  <div className="mb-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
    <div className="min-w-0">
      <h1 className="text-2xl font-bold sm:text-3xl">
        <span className="text-premium">{title}</span>
      </h1>
      {description && <p className="mt-1 text-xs text-gray-500 sm:text-sm">{description}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{children}</div>}
  </div>
)

export default PageHeader
